module.exports = __webpack_public_path__ + "img/bubble catch.c2600b08.png";